import { TicketCreated } from "components/icons/TicketCreated";
import {
  TICKET_CREATED,
  TICKET_PAID,
  TICKET_PAYMENT,
  TICKET_RESOLVED,
  TICKET_UPDATED,
} from "constants/ticket";
import TicketResolve from "static/images/TicketResolve.svg";
import TicketUpdated from "static/images/TicketUpdated.svg";
import { CardStatusType } from "types/Models/reviewDocumentAndBalancingPayment";

export type TicketCardStatusType =
  | typeof TICKET_CREATED
  | typeof TICKET_RESOLVED
  | typeof TICKET_PAYMENT
  | typeof TICKET_UPDATED
  | typeof TICKET_PAID;

export const TicketCardIcon = ({
  status,
}: {
  status: TicketCardStatusType | CardStatusType;
}) => {
  switch (status) {
    case TICKET_CREATED:
    case TICKET_PAYMENT: {
      return <TicketCreated className="t-text-neutral" />;
    }
    case TICKET_PAID:
    case TICKET_RESOLVED: {
      return <img src={TicketResolve} alt="TicketResolve" />;
    }
    case TICKET_UPDATED: {
      return <img src={TicketUpdated} alt="TicketUpdated" />;
    }
    default: {
      return <></>;
    }
  }
};

export const getTicketCardStatus = (
  status: TicketCardStatusType | CardStatusType
) => {
  switch (status) {
    case TICKET_CREATED:
    case TICKET_PAYMENT:
      return "Ticket Created";
    case TICKET_RESOLVED:
      return "Ticket Resolved";
    case TICKET_UPDATED:
      return "Ticket Updated";
    case TICKET_PAID:
      return "Ticket Paid";
    default:
      return "";
  }
};
